export const FAQS = 'md_faqs_GLOBAL';